import React from 'react'
import * as PropTypes from 'prop-types'

import OptionsDropdown from '../../optionsDropdown/OptionsDropdown'
import './AddNewButton.scss'

const AddNewButton = props => {
  return (
    <div className="add-new-button">
      <OptionsDropdown buttonContent={<i className="fa fa-plus" />} buttonClass="button-timeline-overlay" showOnTop>
        <button onClick={props.onClickAddVisit}>Visit</button>
        <button onClick={props.onClickAddMaintenance}>Maintenance</button>
      </OptionsDropdown>
    </div>
  )
}

AddNewButton.propTypes = {
  onClickAddVisit: PropTypes.func.isRequired,
  onClickAddMaintenance: PropTypes.func.isRequired
}

export default AddNewButton
